export default __webpack_public_path__ + "static/media/insurance-coverage-shared-building.9bfc1a24.svg";